import OTPSignInComponent from './OTPSignInComponent'
export default OTPSignInComponent
